/**
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { useCallback, useContext } from "react";
import { EditorMainContext } from "../../../../ui/contexts/EditorMainContext";
import { Icon, ICON_SIZE } from "../../../../ui/components/Icon";

export const MdxCommand: React.FC<Record<string, unknown>> = (props) => {
	const ctx = useContext(EditorMainContext);
	const className = BEM("edt-documentation-mdx-command", undefined, {
		"has-icon": !!props.icon
	});

	const commandId = props['commandId'] as string;
	const commandArgs = props['commandArgs'] as unknown[] | undefined;

	const handlePrimaryClick = useCallback(() => {
		ctx.commandsService
			.execute(commandId, ...(commandArgs || []))
			.catch((err) => {
				console.error("Failed to execute MDX command:", props.commandId, props.commandArgs, err);
			});
	}, [ commandId, commandArgs ]);
	
	return (
		<button
			className={className.toClassName()}
			onClick={handlePrimaryClick}
		>
			{props.icon && (
				<Icon name={props.icon as string} size={ICON_SIZE.XSMALL} />
			)}
			{props.children}
		</button>
	)
};
